<template>
  <div class="-overlay-asset-custom-overlay-fields">
    <div v-for="preset in collagePresets" :key="preset.id">
      <collage-custom-overlay-fields
        :preset="preset"
      ></collage-custom-overlay-fields>
    </div>
  </div>
</template>

<script>
import CollageCustomOverlayFields from './CollageCustomOverlayFields.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CollageCustomOverlays',
  components: {
    CollageCustomOverlayFields,
  },
  computed: {
    collagePresets() {
      // currently only supporting one, might change in the future
      return this.themeInfo.collagePresets;
    },
    ...mapGetters('assetEditor', ['themeInfo']),
  },
};
</script>

<style lang="scss" scoped></style>
